<template>
   <a-modal
    v-model="visible"
    title="项目授权"
    width="30%"
    @ok="handleOk"
    @cancel="onhidden"
  >
    <el-form  ref="fromData" :model="form" >
      <el-form-item v-if="creditCode" label="选择服务商">
        <el-select
          v-model="form.customerCode"
          @change="changeCustomer"
        >
          <el-option
            v-for="item in itemData.customers"
            :key="item.customerCode"
            :label="`${item.ownerTenantName}(${item.customerName})`"
            :value="item.customerCode">
          </el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="">
        <div class="treeBox">
          <el-radio v-model="form.orgMaintainMode" :label="1" @change="radioChange">
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-end"
            >
              <div slot="content" class="tipsBox">{{TEXT_ALL}}</div>
              <span class="itemBox">
                <span>全部项目</span>
                <i class="el-icon-question tipsimg"></i>
              </span>
            </el-tooltip>
          </el-radio>
          <el-radio v-model="form.orgMaintainMode" :label="2" @change="radioChange">
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-end"
            >
              <div slot="content" class="tipsBox">{{TEXT_ORG}}</div>
              <span class="itemBox">
                <span>部分项目</span>
                <i class="el-icon-question tipsimg"></i>
              </span>
            </el-tooltip>
          </el-radio>
          <el-input
            v-model="filterText"
            placeholder="输入关键字进行过滤">
          </el-input>
          <div v-if="form.orgMaintainMode === 1" class="orgBox">
            <el-tree
              ref="tree"
              :props="defaultProps"
              :data="treeData"
              show-checkbox
              node-key="id"
              default-expand-all
              :default-checked-keys="defaultKeys"
              :filter-node-method="filterNode"
              check-strictly
              >
                <span slot-scope="{ node, data }" class="custom-tree-node">
                  <span>{{ node.label.name }}</span>
                  <span v-if="data.childrenOrg && data.childrenOrg.length > 0" class="nodeStyle" @click.stop="checkeChildren(data)">
                    选择所有下级节点
                    </span>
                </span>
            </el-tree>
          </div>
          <div v-if="form.orgMaintainMode === 2" class="orgProjectBox">
            <span v-if="treeData&&treeData.length>0" class="nodeStyle" @click.stop="checkeChildren(treeData)">
              全选
            </span>
            <el-tree
              ref="tree"
              :props="defaultProps"
              :data="treeData"
              show-checkbox
              node-key="id"
              default-expand-all
              :default-checked-keys="defaultKeys"
              :filter-node-method="filterNode"
              check-strictly
              @check="checkNode"
              >
                <span slot-scope="{ node }" class="custom-tree-node">
                  <span v-if="node.label.type === 'PROJECT'" class="labelStyle">项目</span>
                  <span>{{ node.label.name }}</span>
                </span>
            </el-tree>
          </div>
        </div>
      </el-form-item>
    </el-form>
    </a-modal>
</template>

<script>
import {uniqueArray} from '@/utils/util'
import { organizationCorpTree,organizationTree,organizationList,projectAccountRelationUpsert,organizationTreeProject} from '../api'

const TEXT_ALL = '默认具有全部项目权限，新增项目时无需重复配置'
const TEXT_ORG = '仅拥有勾选的项目权限，新增项目时需要手动配置才能拥有新增项目的权限'
  export default {
    name:'ProjectAuthDialog',
    data(){
      return{
        visible:false,
        TEXT_ALL,
        TEXT_ORG,
        form:{
          orgMaintainMode:1
        },
        defaultKeys: [],
        filterText: '',
        defaultProps: {
          children: 'childrenOrg',
          label: 'current'
        },
        treeData:[],
        accountId:null,
        accountData:{},
        orgid:null,
        creditCode: ''
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods:{
      changeCustomer() {
        this.init(this.itemData)
      },
      checkeChildren(data){
        if(data.length===this.$refs.tree.getCheckedNodes().length){
          this.$refs.tree.setCheckedNodes([])
          return
        }
        if(data && data.length > 0){
         data.forEach((e) => {
            this.$refs.tree.setChecked(e.id, true, false)
            this.checkeChildren(e)
          })
        }
      },
      checkNode() {
        // if(renode.current.type === 'PROJECT'){
        //   // 选择项目联动选择上级组织
        //   if(ednode.checkedKeys.includes(renode.id)){
        //     this.$refs.tree.setChecked(renode.parentId, true, false)
        //   }
        // } else if(!ednode.checkedKeys.includes(renode.id)){
        //   const childrenData = this.$refs.tree.getNode(renode.id)
        //   childrenData.childNodes.forEach((e) => {
        //     this.$refs.tree.setChecked(e.data.id, false, false)
        //   })
        // }
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.current.name.indexOf(value) !== -1;
      },
      radioChange(){
        if(this.form.orgMaintainMode === 1){
          this.organizationTree('ORG')
        } else {
          this.organizationTree(null)
        }
      },
      async show(query){
        this.itemData = query
        const {admin,creditCode,customers}=this.$store.state.user
        this.creditCode = creditCode
        if(!creditCode||customers.length===1){
          this.accountData = JSON.parse(localStorage.getItem('accountData'));
          this.orgid = this.accountData.id
        }
        if (this.creditCode && this.itemData.customers[0]?.customerCode) {
          this.$set(this.form, 'customerCode', this.itemData.customers[0].customerCode)
        }
        this.customer =admin
        // 获取组织树
        // this.organizationTree('ORG')
        // 修改
        if(this.itemData.realName){
          this.init(this.itemData)
        }
        this.visible = true;
      },
     async organizationTree( orgType){
      const {userId,creditCode,customers=[],customerCode, customerId}=this.$store.state.user
      const data = {
        accountId: userId,
        orgType,
        objId: customerId,
        accountType: 'CUSTOMER',
        needChildren:true,
        relationType: 'DOWN',
        orgStatus: 'ENABLED',
        source: 'OWN',
        status: 'ENABLE'
      }
      if(!creditCode||customers.length===1){
        data.relationOrgId = this.accountData.id;
        if (orgType) {
          const res = await organizationTree(data)
          this.treeData = this.mapData(res)
        } else {
          const resData = await organizationTreeProject({
            customerCode: customers[0]&&customers[0].customerCode?customers[0].customerCode:customerCode,
            source: 'OWN',
            status: 'ENABLE'
          },{size:1000})
          const records = uniqueArray(resData.records,'id');
          if (records && records.length > 0) {
            const res = records.map(t => ({
                ...t,
                id: t.id,
                parentId: records[0].parentOrgId,
                current: {
                  name: t.projectName,
                  code: t.projectCode,
                  type: "PROJECT",
                  id:t.id,
                }
              }))
            this.treeData = this.mapData(res)
          }else{
            this.treeData = [];
          }
        }
      }else{
        data.creditCode=creditCode
        if (orgType) {
          const current = this.itemData.customers.find(item => item.customerCode === this.form.customerCode)
          this.treeData = [
            {
              current: {
                name: current.customerName,
                id: current.orgId,
                code: current.customerCode,
              },
              id: current.orgId,
              disabled: true,
              childrenOrg: []
            }
          ]
          this.defaultKeys.push(current.orgId)
        } else {
          const resData = await organizationTreeProject({
            customerCode: this.form.customerCode,
            source: 'OWN',
            status: 'ENABLE'
          },{size:1000})
          const records = uniqueArray(resData.records,'id');
          if (records && records.length > 0) {
            const res = records.map(t => ({
              ...t,
              id: t.id,
              parentId: records[0].parentOrgId,
              current: {
                name: t.projectName,
                code: t.projectCode,
                type: "PROJECT",
                id:t.id,
              }
            }))
            this.treeData = this.mapData(res)
          } else {
            this.treeData = [];
          }
          // const res= await organizationCorpTree(data)
          // res[0].id=res[0].current.code
          // this.treeData = this.mapData([{
          //   ...res[0],
          //   id: res[0].id=res[0].current.code
          // }])
        }
      }
    },
    init(itemData){
      this.accountId = itemData.accountId
      // 获取账号绑定的组织
      organizationList({
        accountId: itemData.accountId,
        isAll: false,
        customerCodes: this.form.customerCode ? [this.form.customerCode] : this.$store.state.user.customerCode
      }).then(async (res) => {
        const type=res&&res.length?2:1
        const orgType = type=== 1 ? "ORG" : null
        this.form.orgMaintainMode = type;
        await this.organizationTree(orgType)
        this.filterAccountKey(res)
      })
    },
    filterAccountKey(res){
      res.forEach((e) => {
        this.$refs.tree.setChecked(e.id, true, false)
      })
    },
    mapData(res) {
      const {creditCode}=this.$store.state.user
      return res.map((e) => {
        if(e.id === creditCode){
          this.defaultKeys.push(e.id)
          return {
            ...e,
            disabled: true
          }
        }
        if(e.id === this.accountData.id){
          this.defaultKeys.push(e.id)
          return {
            ...e,
            disabled: true
          }
        }
        if(e.childrenOrg && e.childrenOrg.length > 0){
          return {
            ...e,
            childrenOrg: this.mapData(e.childrenOrg)
          }
        }
        return {
          ...e
        }
      })
    },
     async handleOk(){
        const nodesData = this.$refs.tree.getCheckedKeys()
        if(nodesData.length <= 0){
          this.$message.warning('请选择组织或项目')
          return
        }
        this.onSubmit()
      },
      onSubmit(){
        const checkNodes = this.$refs.tree.getCheckedNodes();
        const projectIds = checkNodes.filter(t => t.current.type === "PROJECT").map(t => t.current.id);
        if(this.form.orgMaintainMode===2&&!projectIds.length){
          this.$message.warning('请至少选择一个项目')
          return 
        }
        const {realName, customerId}=this.$store.state.user
        const data = {
          accountId: this.accountId,
          projectIds,
          createUserName:realName,
        }
        const customer = (this.itemData.customers || []).find(item => item.customerCode === this.form.customerCode)
        data.customerId = customer?.id || customerId
        projectAccountRelationUpsert(data).then(() => {
          this.$message.success('保存成功')
          this.onhidden()
        })
      },
      onhidden(){
         this.visible = false;
      }
    }
  }
</script>

<style lang="less" scoped>
.addaccountBox{
    background: #fff;
    padding: 30px 30px 15px;
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
}
.el-form{
}
.tipsimg{
  width: 16px;
  height: 16px;
  color: #8d8d8e;
  position: absolute;
  top: -10px;
  right: -10px;
}
.tipsBox{
  width: 150px;
}
.labelStyle{
  display: inline-block;
  font-size: 12px;
  line-height: 16px;
  border: 1px solid red;
  color: red;
  padding: 3px;
  border-radius: 3px;
  margin-right: 5px;
  transform: scale(0.8);
}
.treeBox{
  border: 1px solid #ccc;
  padding: 20px;
  box-sizing: border-box;
  max-height: 500px;
  overflow-y: scroll;
}
/deep/ .custom-tree-node{
  width: 100%;
}
.nodeStyle{
  // float: right;
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: right;
  margin-right: 20px;
  color: #25c48d;
  font-size: 12px;
}
.nodeStyle,.el-form-item__content{
  line-height: 1;
}

/deep/ .el-radio__input.is-checked+.el-radio__label{
  color: #25c48d;
}
/deep/ .el-radio__input.is-checked .el-radio__inner{
  border-color: #25c48d;
  background: #25c48d;
}
/deep/ .el-radio__inner:hover{
  border-color: #25c48d;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
  background-color: #25c48d;
  border-color: #25c48d;
}
/deep/ .el-checkbox__inner:hover{
  border-color: #25c48d;
}
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #25c48d;
  border-color: #25c48d;
}
/deep/ .treeBox{
  .el-input__inner{
    height: 30px;
    width: 50%;
    margin-bottom: 20px;
  }
}
.orgProjectBox{
  display: flex;
  flex-direction: row-reverse;
  /deep/ .el-tree {
    width: 100%;
  }
}
</style>